import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "input"]

  connect() {
    const isEnabled = this.inputTarget.value === "true"
    this.buttonTarget.classList.toggle("active", isEnabled)

    // Get ai_service from form
    this.aiService = this.element.closest("form").dataset.aiService

    // Find thinking input
    this.thinkingInput = document.querySelector('[data-thinking-toggle-target="input"]')
    if (this.thinkingInput) {
      this.thinkingInput.addEventListener("change", () => this.updateSearchButtonState())
      this.updateSearchButtonState()  // initial check
    }
  }

  toggle() {
    // Don’t toggle if button is disabled
    if (this.buttonTarget.disabled) return

    const isEnabled = this.inputTarget.value === "true"
    this.inputTarget.value = (!isEnabled).toString()
    this.buttonTarget.classList.toggle("active", !isEnabled)
  }

  updateSearchButtonState() {
    if (!this.buttonTarget) return

    const thinking = this.thinkingInput.value === "true"
    const shouldDisable = (this.aiService === "openai" && thinking)

    // Disable or enable the button based on OpenAI + thinking state
    this.buttonTarget.disabled = shouldDisable
    this.buttonTarget.style.cursor = shouldDisable ? "not-allowed" : "pointer"
    this.buttonTarget.title = shouldDisable ? "OpenAI has temporarily disabled web search with reasoning" : "Enable Web Search"
    $(this.buttonTarget).tooltip('dispose').tooltip()
    this.buttonTarget.style.opacity = shouldDisable ? "0.7" : "1"

    // If disabled by thinking — force search value to false and remove active class
    if (shouldDisable) {
      this.inputTarget.value = "false"
      this.buttonTarget.classList.remove("active")
    }
  }
}
